// extracted by mini-css-extract-plugin
export default {"clientes":"Clientes_clientes__sLZ8f"};